export enum QueryState {
  idle = "idle",
  noItems = "noItems",
  loading = "loading",
  success = "success",
  error = "error"
}
